var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"popper-class":_vm.zIndex ? 'smr-tooltip smr-tooltip--index': 'smr-tooltip',"effect":"dark","hide-after":2700,"content":_vm.content,"placement":_vm.position,"open-delay":700,"disabled":_vm.mobile ? true: false,"transition":"el-fade-in-linear"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }